import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import { USER_TOKEN_KEY } from '@/store/authModule';
// import { USER_TOKEN_KEY } from '@/store/authModule';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    name: 'Home',
    path: '/home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/HomeView'),
    meta: { form: true },
  },
  {
    path: '/user/password-recover/:passHash',
    name: 'Pass',
    component: () => import(/* webpackChunkName: "pass" */ '@/views/Pass'),
  },
  {
    path: '/authors/:authorId',
    name: 'Author',
    component: () => import(/* webpackChunkName: "author" */ '@/views/AuthorView'),
  },
  {
    name: 'Form',
    path: '/author-form',
    component: () => import(/* webpackChunkName: "form" */ '@/views/AuthorForm'),
  },
  {
    name: 'Auth',
    path: '/author/:authorId',
    component: () => import(/* webpackChunkName: "form" */ '@/views/DisciplineView'),
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const go = to.fullPath.split('/');
  let storeNumber = '';

  if (go[1] === 'authors') {
    storeNumber = go[2];
  } else if (go[2] === 'password-recover') {
    storeNumber = go[3];
  }

  const publicPages = [
    '/home',
    '/login',
    '/author-form',
    `/authors/${storeNumber}`,
    `/user/password-recover/${storeNumber}`,
  ];

  const isPublicPage = publicPages.includes(to.path);
  const loggedIn = localStorage.getItem(USER_TOKEN_KEY);

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (!isPublicPage && !loggedIn) {
    next('/home');
  } else if (isPublicPage) {
    next();
  } else {
    axios.defaults.headers = {
      Authorization: `Bearer ${loggedIn}`,

    };
    next();
  }
});

export default router;
